import dayjs from 'dayjs';

/**
 * Calculate totals from detail rows
 */
export const calculateTotals = (detailRows: MuaHangRecord[] = []) => {
  const tien_nt = detailRows.reduce((sum: number, row: { tien_nt: number }) => sum + (row.tien_nt || 0), 0);
  const so_luong = detailRows.reduce((sum: number, row: { so_luong: number }) => sum + (row.so_luong || 0), 0);
  const chiet_khau = detailRows.reduce((sum: number, row: { ck_nt: number }) => sum + (row.ck_nt || 0), 0);
  const thue_nt = detailRows.reduce((sum: number, row: { thue_nt: number }) => sum + (row.thue_nt || 0), 0);
  const thanh_toan = tien_nt + thue_nt;

  return {
    tong_tien: tien_nt,
    tong_so_luong: so_luong,
    tong_chiet_khau: chiet_khau,
    tong_thue: thue_nt,
    tong_thanh_toan: thanh_toan
  };
};

export const handleUpdateRowFields = (
  row: MuaHangRecord,
  field: string,
  newValue: MuaHangRecord,
  globalCkTlNt?: number
) => {
  if (
    field === 'so_luong' ||
    field === 'gia_nt' ||
    field === 'ma_thue_data' ||
    field === 'ma_dv_data' ||
    field === 'tl_ck'
  ) {
    let gia_nt;
    let gia_nt_manual = row.gia_nt_manual;
    let ma_thue_manual = row.ma_thue_manual;
    let tl_ck_manual = row.tl_ck_manual;
    let ma_thue_data = row.ma_thue_data;
    let thue_suat;

    const so_luong = field === 'so_luong' ? newValue : row.so_luong;

    if (field === 'gia_nt') {
      gia_nt = newValue;
      gia_nt_manual = true;
    } else if (field === 'ma_dv_data') {
      gia_nt = newValue?.gia_nt || 0;
      ma_thue_data = newValue?.ma_thue_data || null;
      gia_nt_manual = false;
      ma_thue_manual = false;
      tl_ck_manual = false;
    } else if (field === 'tl_ck') {
      tl_ck_manual = true;
      gia_nt = row.gia_nt || row.ma_dv_data?.gia_nt || 0;
    } else {
      gia_nt = row.gia_nt || row.ma_dv_data?.gia_nt || 0;
    }

    if (field === 'ma_thue_data') {
      thue_suat = newValue?.thue_suat || 0;
      ma_thue_manual = true;
      ma_thue_data = newValue;
    } else if (field === 'tl_ck') {
      thue_suat = row.ma_thue_data?.thue_suat || row.ma_dv_data?.ma_thue_data?.thue_suat || 0;
    } else {
      if (ma_thue_manual) {
        thue_suat = row.ma_thue_data?.thue_suat || 0;
      } else {
        thue_suat = row.ma_dv_data?.ma_thue_data?.thue_suat || row.ma_thue_data?.thue_suat || 0;
      }
    }
    let tl_ck;
    if (field === 'tl_ck') {
      tl_ck = newValue;
    } else if (tl_ck_manual) {
      tl_ck = row.tl_ck;
    } else if (globalCkTlNt !== undefined) {
      tl_ck = globalCkTlNt;
    } else {
      tl_ck = row.tl_ck;
    }

    const tien_tck_nt = (Number(so_luong) || 0) * (Number(gia_nt) || 0);
    const ck_nt = (tien_tck_nt * (Number(tl_ck) || 0)) / 100;
    const tien_nt = tien_tck_nt - ck_nt;
    const thue_nt = (tien_nt * (Number(ma_thue_data?.thue_suat) || 0)) / 100;
    return {
      gia_nt,
      gia_nt_manual,
      ma_thue_manual,
      tl_ck_manual,
      ma_thue_data,
      tien_nt,
      thue_nt: Math.round(thue_nt),
      ck_nt,
      tien_tck_nt
    };
  }
  return {};
};

export const recalculateWithNewChietKhau = (row: MuaHangRecord, newChietKhau: number) => {
  const so_luong = row.so_luong || 0;
  const gia_nt = row.gia_nt || row.ma_dv_data?.gia_nt || 0;
  const thue_suat = row.ma_thue_data?.thue_suat || row.ma_dv_data?.ma_thue_data?.thue_suat || 0;

  const tien_tck_nt = (Number(so_luong) || 0) * (Number(gia_nt) || 0);
  const ck_nt = (tien_tck_nt * (Number(newChietKhau) || 0)) / 100;
  const tien_nt = tien_tck_nt - ck_nt;
  const thue_nt = (tien_nt * (Number(thue_suat) || 0)) / 100;

  return {
    ck_nt,
    tien_nt,
    thue_nt: Math.round(thue_nt),
    tien_tck_nt
  };
};

export const calculateNgayKetThucKh = (ngayKH?: string | null, soKy?: number | null) => {
  if (!ngayKH || !soKy || soKy <= 0) return null;

  const start = dayjs(ngayKH, ['YYYY-MM-DD'], true);
  if (!start.isValid()) return null;

  return start.add(Number(soKy), 'month').subtract(1, 'day').format('YYYY-MM-DD');
};

export const calculateGiaTriKH1Ky = (nguyenGiaNt: number | string, soKyKh: number | string) => {
  const nguyenGia = Number(nguyenGiaNt) || 0;
  const soKy = Number(soKyKh) || 0;
  if (soKy === 0) {
    return 0;
  }
  return nguyenGia / soKy;
};

export const calculateGiaTriConLai = (nguyenGiaNt: number | string, giaTriDaKHNt: number | string) => {
  const nguyenGia = Number(nguyenGiaNt) || 0;
  const giaTriDaKH = Number(giaTriDaKHNt) || 0;
  return nguyenGia - giaTriDaKH;
};
